import { useState } from 'react';

import type { StartConflict } from '@/types/scheduleExpectation';

// Runs a submit-time conflict check before committing a payload. If conflicts are
// found, the payload is held until the caller confirms or cancels via the modal.
export function useConflictGatedSubmit<TPayload>() {
  const [pendingConflicts, setPendingConflicts] = useState<StartConflict[]>([]);
  const [pendingPayload, setPendingPayload] = useState<TPayload | null>(null);

  const clearPending = () => {
    setPendingConflicts([]);
    setPendingPayload(null);
  };

  const guardSubmit = async (
    payload: TPayload,
    checkConflicts: () => Promise<StartConflict[]>,
    doSubmit: (payload: TPayload) => void
  ) => {
    const conflicts = await checkConflicts();

    if (conflicts.length > 0) {
      setPendingConflicts(conflicts);
      setPendingPayload(payload);
      return;
    }

    doSubmit(payload);
  };

  const confirmPending = (doSubmit: (payload: TPayload) => void) => {
    if (pendingPayload) doSubmit(pendingPayload);
    clearPending();
  };

  return { pendingConflicts, guardSubmit, confirmPending, clearPending };
}
